module.exports = __webpack_public_path__ + "static/img/cocina_16.cfb6e182.png";